import { render, staticRenderFns } from "./ThinkTankClaimSource.vue?vue&type=template&id=37ec0607&"
import script from "./ThinkTankClaimSource.vue?vue&type=script&lang=js&"
export * from "./ThinkTankClaimSource.vue?vue&type=script&lang=js&"
import style0 from "./ThinkTankClaimSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports